<template>
  
  <v-container fluid grid-list-lg>
    <v-layout row align-center>
      <v-flex class="text-xs-center">
        <div class="spinner">
          <div class="double-bounce1"></div>
          <div class="double-bounce2"></div>
        </div>
      </v-flex>
    </v-layout>
  </v-container>

</template>

<script>

export default {
  name: 'Oauth',
  data () {
    return {
    }
  },
  mounted: function() {
    this.checkAuthProvider();
  },
  computed: {
    cdn: function() {
      return this.$root.cdn;
    },
    provider: function() {
      return this.$route.params.provider;
    }
  },
  methods: {
    validProvider: function() {
      switch(this.provider) {
        //case 'facebook':
        //case 'twitter':
        case 'google':
          return true;
          break;
        default:
          return false;
      }
    },
    checkAuthProvider: function() {
      if(!this.validProvider()) {
        this.$swal.fire('Invalid Provider', 'Invalid Oauth provider');
        this.$router.replace({name: 'auth'});
        return;
      }
      if(this.provider == 'google') {
        let params = {
          provider: 'google',
          token: this.$route.query.code,
          redirect_uri: process.env.VUE_APP_URL
        }
        this.$http.post('auth/verify-oauth', params)
          .then(response => {
            let redirect = this.$store.getters.oauthRedirect;
            this.$store.commit('setOauthRedirect',null);
            this.$store.commit('setReferredBy', null);
            this.$store.commit('updateAccessToken', response.data.access_token);
            delete(response.data.access_token);
            this.$store.commit('setUser', response.data);
            if(redirect && redirect != '') {
              this.$router.push(redirect);
            } else {
              this.$router.push({name: 'account-trips'});
            }
            this.$store.dispatch('checkForUpdates');
          })
          .catch(err => {
            this.$swal.fire('Error', 'There was an issue logging in with the provider', 'error');
            this.$router.push({name: 'auth'});
          })
      }
    }
  }
}
</script>